import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid2";
import DownloadButton from "src/components/shared/button/DownloadButton";
import BlankCard from "src/components/shared/BlankCard";
import { Divider, Typography, useMediaQuery } from "@mui/material";
import BackButton from "src/components/shared/button/BackButton";
import { useDispatch, useSelector } from "react-redux";
import ErrorView from "src/components/errors/ErrorView";
import { useMsal } from "@azure/msal-react";
import { setReservationClientVoucherVisibility, setReservationOverviewVisibility } from "src/store/reservations/slices/hotels/HotelDetailSlice";
import { fetchGeneratedAllClientVoucherDetails, fetchGeneratedSingleClientVoucherDetails } from "src/store/reservations/slices/ReservationsManagerSlice";
import { useParams } from "react-router";
import { fetchAgentHeaderImage } from "src/store/agent/AgentManagerSlice";
import ReservationsClientVoucherSkeleton from "./ReservationsClientVoucherSkeleton";
import VoucherSectionsContainer from "./VoucherSectionsContainer";

const ReservationsClientVoucher = () => {
  const { clientVoucherDetails } = useSelector((state) => state.reservationsSummaryReducer);
  const contentRef = useRef();
  const { instance, accounts } = useMsal();
  const [headerImage, setHeaderImage] = useState(null);
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [voucherDetails, setVoucherDetails] = useState(null);
  const { reservationId, voucherId, itemReference } = useParams();
  const [isImageLoading, setIsImageLoading] = useState(true);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (reservationId && voucherId) {
        try {
          setIsImageLoading(true);
          dispatch(setReservationOverviewVisibility(false));
          dispatch(setReservationClientVoucherVisibility(true));

          const voucher = await dispatch(
            itemReference
              ? fetchGeneratedSingleClientVoucherDetails(instance, accounts, reservationId, voucherId, itemReference)
              : fetchGeneratedAllClientVoucherDetails(instance, accounts, reservationId, voucherId)
          );

          setVoucherDetails(voucher);

          const imageResponse = await dispatch(fetchAgentHeaderImage(instance, accounts, voucher.Details.AgentId));

          if (imageResponse) {
            setHeaderImage(URL.createObjectURL(imageResponse));
          }

          setIsImageLoading(false);
        } catch (err) {
          setError(err);
          setIsImageLoading(false);
        }
      }
    };

    fetchData();
  }, [instance, accounts, dispatch, reservationId, voucherId]);

  const handleClose = () => {
    setError(null);
  };

  if (isImageLoading || isGeneratingPdf) {
    return (
      <Grid container spacing={0}>
        <Grid item size={12}>
          <ReservationsClientVoucherSkeleton count={5} lgUp={lgUp} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={0}>
      <Grid item size={12}>
        {error ? (
          <ErrorView error={error} onClose={handleClose} />
        ) : (
          <>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item xs={8} sm={8} lg={7}>
                <Typography variant="h5" m={2}>
                  View Voucher Details
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                sm={4}
                lg={5}
                m={2}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <DownloadButton
                  title={`Voucher-${clientVoucherDetails?.VoucherNumber}`}
                  targetRef={contentRef}
                  onDownloadStart={() => setIsGeneratingPdf(true)}
                  onDownloadEnd={() => setIsGeneratingPdf(false)}
                />
              </Grid>
            </Grid>
            <Divider />
            <Grid item p={3} ref={contentRef}>
              <BlankCard>
                <VoucherSectionsContainer
                  clientVoucherDetails={clientVoucherDetails}
                  headerImage={headerImage}
                  voucherDetails={voucherDetails}
                />
              </BlankCard>
            </Grid>
          </>
        )}

        <Grid pt={3}>
          <BackButton />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReservationsClientVoucher;